import script from "./ProfessionalView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalView.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalView.vue?vue&type=style&index=0&id=24bee693&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24bee693"]])

export default __exports__